import React, { useContext, useEffect, useState } from "react"
import "./style.scss"
import { Button, MenuItem, Pagination, Rating, Select } from "@mui/material"
import { MyContext } from "../theme/adminLayout"
import { IoClose } from "react-icons/io5";
import { approveReview, getApprovedReviews, getPendingReviews, getRejectedReviews, rejectReview } from "services/admin/reviewService"
import { FaCheck, FaRegEye } from "react-icons/fa"
import ModalReview from "component/user/modal_review"
import Swal from "sweetalert2";
import { PacmanLoader } from "react-spinners";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { introspective } from "services/tokenService";
const ReviewList = () => {
    const context = useContext(MyContext);
    const token = localStorage.getItem("token")
    const { status } = useParams();
    const navigate = useNavigate()

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [page, setPage] = useState(Number(searchParams.get('page') || 1));

    const [totalPage, setTotalPage] = useState(1);

    const [isLoading, setIsLoading] = useState(false);

    const [modal, setModal] = useState(false);
    const [selectedReview, setSelectedrReview] = useState(null);
    const toggleModal = (reviewID) => {
        setSelectedrReview(reviewID); 
        setModal((prev) => !prev);  
    };

    const [reviewPermission, setReviewPermission] = useState(""); // lưu xem có quyền qly đánh giá không
        
    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const response = await introspective(token);
                if (response.data) {
                    setReviewPermission(response.data.permissions.some(permission => permission.id === 6)); // id 6 là đánh giá
                }
            } 
            catch (error) {
                console.log("introspective failed:", error);
            } 
        };

        fetchPermissions();

    }, [token]);

    const [refreshFetchReview, setRefreshFetchReview] = useState(false); // để khi duyệt hoặc huỷ xong thì fetchReview lại để hiển thị đánh giá

    const [statusReview, setStatusReview] = useState(0);
    const [reviews, setReviews] = useState()

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        const day = String(date.getDate()).padStart(2, '0'); 
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const getStatusClass = (status) => {
        if (status === "Đang chờ duyệt") {
            return "pending";
        } 
        else if (status === "Đã duyệt") {
            return "approved";
        } 
        else if (status === "Bị từ chối") {
            return "rejected";
        } 
        else {
            return "";
        }
    };

    useEffect(() => {
        if (status === "pending") {
          setStatusReview(0);
        } 
        else if (status === "approved") {
          setStatusReview(1);
        } 
        else if (status === "rejected") {
          setStatusReview(2);
        }
    }, [status]);

    const handleStatusClick = (status) => {
        if (status === 0) {
            setStatusReview(0);
            navigate(`/admin/list-review/pending`);
            setPage(1)
        }
        else if (status === 1) {
            setStatusReview(1);
            navigate(`/admin/list-review/approved`);
            setPage(1)
        }
        else if (status === 2) {
            setStatusReview(3);
            navigate(`/admin/list-review/rejected`);
            setPage(1)
        }
    }

    const handleChangeReview = (event) => {
        setStatusReview(event.target.value);
    };

    const handleChangePage = (event, value) => {
        if (statusReview === 0) {
            setPage(value);
            navigate(`/admin/list-review/pending?page=${value}`);
        }
        else if (statusReview === 1) {
            setPage(value);
            navigate(`/admin/list-review/approved?page=${value}`);
        }
        else if (statusReview === 2) {
            setPage(value);
            navigate(`/admin/list-review/rejected?page=${value}`);
        }
    }

    // getReviewByStatus
    useEffect(() => {
        if (statusReview === 0) {
            const fetchPendingReviews = async () => {
                setIsLoading(true)
                try {
                    const response = await getPendingReviews(token, page - 1)
                    setReviews(response.data.content)
                    setTotalPage(response.data.page.totalPages);
                    console.log(response.data.content)
                } 
                catch (error) {
                    console.log("fetchPendingReviews", error)
                }
                finally {
                    setIsLoading(false)
                }
    
            }
            fetchPendingReviews();
        } 
        else if (statusReview === 1) {
            const fetchApprovedReviews = async () => {
                setIsLoading(true)
                try {
                    const response = await getApprovedReviews(token, page - 1)
                    setReviews(response.data.content)
                    setTotalPage(response.data.page.totalPages);
                    console.log(response.data.content)
                } 
                catch (error) {
                    console.log("fetchApprovedReviews", error)
                }
                finally {
                    setIsLoading(false)
                }
            }
            fetchApprovedReviews();
        }
        else if (statusReview === 2) {
            const fetchRejectedReviews = async () => {
                setIsLoading(true)
                try {
                    const response = await getRejectedReviews(token, page - 1)
                    setReviews(response.data.content)
                    setTotalPage(response.data.page.totalPages);
                    console.log(response.data.content)
                } 
                catch (error) {
                    console.log("fetchRejectedReviews", error)
                }
                finally {
                    setIsLoading(false)
                }
            }
            fetchRejectedReviews();
        }
    }, [statusReview, token, page, refreshFetchReview])

    const handleApprovedReview = async (reviewID) => {
        const result = await Swal.fire({
            title: "Xác nhận duyệt đánh giá?",
            // text: `Xác nhận sẽ xoá Sách "${book.title}"!`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Duyệt!",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await approveReview(token, reviewID);
                console.log(response)
                if (response.message === "Review has been approved!") {
                    Swal.fire({
                        title: "Duyệt thành công!",
                        icon: "success"
                    }).then(() => {
                        // window.location.reload();
                        setRefreshFetchReview((prev) => !prev);
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Duyệt đánh giá không thành công.",
                        icon: "error"
                    });
                }
            } 
            catch (error) {
                console.log("handleApprovedReview", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Duyệt đánh giá không thành công.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
        }
    }

    const handleRejectedReview = async (reviewID) => {
        const result = await Swal.fire({
            title: "Xác nhận từ chối duyệt đánh giá?",
            // text: `Xác nhận sẽ xoá Sách "${book.title}"!`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận!",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await rejectReview(token, reviewID);
                console.log(response.data)
                if (response.message === "Review has been rejected!") {
                    Swal.fire({
                        title: "Từ chối duyệt thành công!",
                        icon: "success"
                    }).then(() => {
                        // window.location.reload();
                        setRefreshFetchReview((prev) => !prev);
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        // text: "Duyệt đánh giá không thành công.",
                        icon: "error"
                    });
                }
            } 
            catch (error) {
                console.log("handleRejectedReview", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    // text: "Duyệt đánh giá không thành công.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
        }
    }
    console.log(isLoading)
    return (
        <div className="ReviewList">
            <div className="card border-0 p-4 mt-5">
                <div className="headCard d-flex">
                    <h5>Đánh giá</h5>
                </div>
                <hr />

                <div className="row cardFilters">
                    <h4>Trạng thái</h4>
                    <div className="col-4">
                        <Select
                            className="custom-select"
                            value={statusReview}
                            onChange={handleChangeReview}
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                            MenuProps={{
                                disableScrollLock: true,
                                PaperProps: {
                                    style: {
                                        maxHeight: 200, 
                                        overflowY: 'auto',
                                    },
                                },
                            }}
                            sx={{
                                '&.MuiOutlinedInput-root': {
                                    // '& fieldset': {
                                    //     borderColor: 'red',
                                    // },
                                    '&:hover fieldset': {
                                        borderColor: '#9d2ff7',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#9d2ff7',
                                    },
                                },
                            }}
                        >
                            <MenuItem disabled>
                                <em>Trạng thái</em>
                            </MenuItem>

                            <MenuItem value={0} onClick={() => handleStatusClick(0)}>Đang chờ duyệt</MenuItem>
                            <MenuItem value={1} onClick={() => handleStatusClick(1)}>Đã duyệt</MenuItem>
                            <MenuItem value={2} onClick={() => handleStatusClick(2)}>Từ chối duyệt</MenuItem>

                        </Select>
                    </div>
                    {/* <div className="col-8 d-flex">
                        <Button onClick={handleHidden} className="ms-auto" color="secondary">{isHidden ? <FaRegEyeSlash/> : <FaRegEye/>}</Button>
                    </div> */}
                </div>

                <div className="table-responsive mt-3">
                    <table className="table table-bordered v-align">
                        <thead className="thead-dark">
                            <tr>
                                <th>ID</th>
                                <th>SÁCH</th>
                                <th>KHÁCH HÀNG</th>
                                <th>NGÀY</th>
                                <th>SỐ SAO</th>
                                <th>NỘI DUNG</th>
                                <th>TRẠNG THÁI</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>

                        <tbody>
                            {reviews && reviews.length > 0 ? (
                                reviews.map((review, index) => (
                                    <>
                                        <tr key={review.reviewID}>
                                            <td>{index+1}</td>
                                            <td>
                                                <div className="d-flex productBox"
                                                style={{ width: context.isToggleSidebar ? '18rem' : '8rem' }}>
                                                    <div className="imgWrapper1">
                                                        <div className="img">
                                                            <img className="w-100" src={review.item.imageLink} alt="" loading="lazy"/>
                                                        </div>
                                                    </div>
                                                    <h6>{review.item.title}</h6>
                                                </div>
                                            </td>
                                            <td>{review.reviewer}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>{formatDate(review.dateReview)}</td>
                                            <td>
                                                <Rating
                                                    name="read-only"
                                                    value={review.rating}
                                                    precision={0.5}
                                                    readOnly
                                                    size="small"
                                                />
                                            </td>
                                            <td>
                                                <div className="d-flex commentBox"
                                                style={{ width: context.isToggleSidebar ? '18rem' : '12rem' }}>
                                                    <h6>{review.comment}</h6>
                                                </div>
                                            </td>
                                            <td className={getStatusClass(review.status)} style={{ whiteSpace: "nowrap", padding: '5px'}}>
                                                <span>{review.status}</span>
                                            </td>
                                            <td>
                                                <div className="actions d-flex align-items-center">
                                                    {statusReview === 0 ? (
                                                        <>
                                                            <Button 
                                                                className="secondary" 
                                                                color="secondary"
                                                                onClick={() => toggleModal(review.reviewID)}
                                                            >
                                                                <FaRegEye/>
                                                            </Button>
                                                            <Button 
                                                                className="success" 
                                                                color="success"
                                                                onClick={() => {
                                                                    if (!reviewPermission) {
                                                                        Swal.fire({
                                                                            title: "Không có quyền!",
                                                                            text: "Bạn không có quyền duyệt đánh giá.",
                                                                            icon: "error"
                                                                        });
                                                                    }
                                                                    else {
                                                                        handleApprovedReview(review.reviewID)
                                                                    }
                                                                    
                                                                }}
                                                            >
                                                                <FaCheck />
                                                            </Button>
                                                            <Button 
                                                                className="error" 
                                                                color="error"
                                                                onClick={() => {
                                                                    if (!reviewPermission) {
                                                                        Swal.fire({
                                                                            title: "Không có quyền!",
                                                                            text: "Bạn không có quyền từ chối đánh giá.",
                                                                            icon: "error"
                                                                        });
                                                                    }
                                                                    else {
                                                                        handleRejectedReview(review.reviewID)
                                                                    }
                                                                }}
                                                            > 
                                                                <IoClose />
                                                            </Button>
                                                        </>
                                                    ) : (
                                                        <Button 
                                                            className="secondary" 
                                                            color="secondary"
                                                            onClick={() => toggleModal(review.reviewID)}
                                                        >
                                                            <FaRegEye/>
                                                        </Button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        {modal && selectedReview === review.reviewID && (
                                            <ModalReview value={review.rating} content={review.comment} onClose={toggleModal} />
                                        )} 
                                    </>
                                ))
                            ) : (
                                <tr></tr>
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex tableFooter">
                        <Pagination 
                            className="ms-auto" 
                            count={totalPage} 
                            color="secondary"
                            page={page} 
                            onChange={handleChangePage}
                        />
                    </div>
                </div>
            </div>

            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    )
}

export default ReviewList